import { createContext, useContext } from 'react';
import { useInsurancePage } from './components/InsurancePage/InsurancePage.hook';

export const InsurancePageContext = createContext<ReturnType<typeof useInsurancePage>>(null);
export const useInsurancePageContext = () => useContext(InsurancePageContext);
